import AppModal from '@components/modals/AppModal';

function StartPointDescriptionEditor({
  editor,
  isDescriptionEditorReady,
  setQuillHost,
  onSave,
  onClose
}) {
  return (
    <AppModal
      isOpen={editor.isOpen}
      onClose={onClose}
      title={`${
        editor.field === "additionalInfoDescription"
          ? "additional description"
          : "description"
      } (${editor.languageIso})`}
      size="lg"
    >
      <div className="tour-add-editor">
        {!isDescriptionEditorReady ? <p className="tour-add-editor-loading">Loading editor...</p> : null}
        <div ref={setQuillHost} className="tour-add-quill" />
        <div className="tour-add-editor-actions">
          <button type="button" className="button-primary" onClick={onSave}>
            Save
          </button>
          <button type="button" className="button-ghost" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </AppModal>
  );
}

export default StartPointDescriptionEditor;
